
(function () {
  // fire once per browser session
  var ONCE_KEY = 'fb_session_logged';

  // don't overwrite an existing dataLayer
  if (!Array.isArray(window.dataLayer)) window.dataLayer = [];

  function getParam(n) {
    try {
      var v = new URLSearchParams(location.search).get(n);
      return v && v.trim() ? v : null;
    } catch(e){ return null; }
  }
  function isFBReferrer(ref) {
    return /(^|\.)facebook\.com|(^|\.)m\.facebook\.com|(^|\.)l\.facebook\.com|(^|\.)fb\.me|(^|\.)instagram\.com/i.test(ref||'');
  }
  function safeHostname(u) {
    try { return new URL(u).hostname.toLowerCase(); } catch(e){ return ''; }
  }

  function fromFacebook() {
    var src = (getParam('utm_source') || '').toLowerCase();
    var hasFbclid = !!getParam('fbclid');
    var utmIsFB = src === 'facebook' || src === 'meta' || src === 'instagram';
    return hasFbclid || utmIsFB || isFBReferrer(document.referrer);
  }

  function detectSourceMedium() {
    var source = (getParam('utm_source') || '').toLowerCase();
    var medium = (getParam('utm_medium') || (getParam('fbclid') ? 'paid_social' : 'social')).toLowerCase();
    if (!source) {
      var refHost = safeHostname(document.referrer);
      source = refHost || 'facebook';
    }
    return { source: source, medium: medium };
  }

  function pushEventOnce() {
    if (!fromFacebook()) return;
    if (sessionStorage.getItem(ONCE_KEY) === '1') return;

    var sm = detectSourceMedium();

    // SAME event name + params as before:
    window.dataLayer.push({
      event: 'facebook_session',
      source: sm.source,
      medium: sm.medium,
      campaign: getParam('utm_campaign') || '(not set)',
      content: getParam('utm_content') || undefined,
      term: getParam('utm_term') || undefined,
      referrer: document.referrer || '(direct)',
      page_location: location.href
    });

    sessionStorage.setItem(ONCE_KEY, '1');
  }

  // run as early as possible
  pushEventOnce();

  // SPA-safe: re-check on history changes but won't double-fire thanks to ONCE_KEY
  (function hookHistory(){
    var _ps = history.pushState, _rs = history.replaceState;
    function rerun(){ try { pushEventOnce(); } catch(e){} }
    if (_ps) history.pushState = function(){ var r=_ps.apply(this, arguments); setTimeout(rerun,0); return r; };
    if (_rs) history.replaceState = function(){ var r=_rs.apply(this, arguments); setTimeout(rerun,0); return r; };
    window.addEventListener('popstate', rerun);
    window.addEventListener('pageshow', function(e){ if (e.persisted) rerun(); });
  })();
})();
